/* Smoovees redesign: scroll reveal, the Eight-Minute Ritual timer and the sticky add-to-cart bar. */
(function () {
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = window.Shopify && window.Shopify.designMode;

  function initReveal() {
    const items = document.querySelectorAll('[data-sm-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reduced || inEditor || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach((el) => io.observe(el));
  }

  function formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initRitual() {
    const rituals = Array.from(document.querySelectorAll('.sm-ritual:not(.sm-ritual--compact)'));
    if (!rituals.length || reduced) return;
    rituals.forEach((el) => el.classList.add('sm-ritual--live'));
    let ticking = false;

    function update() {
      ticking = false;
      const mid = window.innerHeight * 0.55;
      rituals.forEach((el) => {
        const steps = Array.from(el.querySelectorAll('.sm-ritual__step'));
        const time = el.querySelector('[data-sm-time]');
        const total = Number(el.dataset.smSeconds) || 480;
        if (!steps.length) return;
        const first = steps[0].getBoundingClientRect();
        const last = steps[steps.length - 1].getBoundingClientRect();
        const span = last.top + last.height / 2 - first.top;
        const p = Math.min(1, Math.max(0, (mid - first.top) / (span || 1)));
        el.style.setProperty('--sm-p', p.toFixed(3));
        if (time) time.textContent = formatTime(Math.round((p * total) / 5) * 5);
        let active = 0;
        steps.forEach((step, i) => {
          if (step.getBoundingClientRect().top <= mid) active = i;
        });
        steps.forEach((step, i) => step.classList.toggle('is-active', i === active));
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initSticky() {
    const bar = document.querySelector('.sm-sticky');
    if (!bar) return;
    const target = document.querySelector('product-info product-form, product-info .product-form');
    const button = bar.querySelector('[data-sm-sticky-go]');
    if (!target || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        bar.classList.toggle('is-on', !entry.isIntersecting);
      });
    });
    io.observe(target);
    if (button) {
      button.addEventListener('click', () => {
        const anchor = document.querySelector('product-info .product__info-container') || target;
        anchor.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  function initCartNotes() {
    const el = document.querySelector('[data-sm-cart-notes]');
    // subscribe and PUB_SUB_EVENTS come from the theme's pubsub.js and constants.js
    if (!el || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    const id = el.dataset.smCartNotes;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fetch(window.location.pathname + '?section_id=' + id)
        .then((r) => r.text())
        .then((html) => {
          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sm-cart-notes]');
          const current = document.querySelector('[data-sm-cart-notes]');
          if (current && next) current.innerHTML = next.innerHTML;
          else if (current && !next) current.remove();
        })
        .catch(() => {});
    });
  }

  function initVideos() {
    const videos = document.querySelectorAll('video[data-sm-autoplay]');
    if (!videos.length || reduced || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const attempt = video.play();
            if (attempt && attempt.catch) attempt.catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    videos.forEach((video) => io.observe(video));
  }

  function initApply() {
    document.querySelectorAll('form[data-sm-apply]').forEach((form) => {
      const sheet = form.getAttribute('data-sheet');
      if (!sheet || !navigator.sendBeacon) return;
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        const copy = new FormData();
        new FormData(form).forEach((value, key) => {
          const match = key.match(/^contact\[(.+)\]$/);
          if (match && typeof value === 'string') copy.append(match[1] === 'body' ? 'Why join' : match[1], value);
        });
        navigator.sendBeacon(sheet, copy);
      });
    });
  }

  function init() {
    root.classList.add('sm-js');
    initReveal();
    initRitual();
    initSticky();
    initCartNotes();
    initVideos();
    initApply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', initReveal);
})();
